/**
 * Component Registry for Rye Bunker Hill
 * 
 * Inherits from @vibesites-price-brothers/theme-rise and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-price-brothers/theme-rise/registry';
import { Hero } from './components/Hero';
import { HeroSolidBG } from './components/HeroSolidBG';
import { TabbedCallouts } from './components/TabbedCallouts';
import { PinnedCallouts } from './components/PinnedCallouts';
import { Header } from './components/Header';
import { SitemapContent } from './components/SitemapContent';
import { ThankYouContent } from './components/ThankYouContent';

/**
 * Property-specific component overrides.
 * Uncomment and customize components as needed.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  Hero,
  HeroSolidBG,
  TabbedCallouts,
  PinnedCallouts,
  Header,
  SitemapContent,
  ThankYouContent,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
